'use client'

import { cx } from 'utils/cx'
import { ClientLink } from 'utils/link/client'

import { BUTTON_VARIANT } from '../../Button.types'
import type { ContentLinkProps } from '../../ContentLink'
import type { ButtonClientLinkProps } from '../ButtonClientLink.types'

import styles from './ClientLinkContentLink.module.scss'

export function ClientLinkContentLink(
	props: ButtonClientLinkProps & ContentLinkProps
): React.ReactNode {
	const { variant = BUTTON_VARIANT.DEFAULT, className, ...rest } = props

	return <ClientLink {...rest} className={cx(className, styles[variant])} />
}
